import { apiClient } from "../Config/ApiClient";

export const retrieveSetting = (token) =>
  apiClient.get(`/setting`, { headers: { Authorization: token } });

export const updateSetting = (id, body, token) =>
  apiClient.put(`/setting/${id}`, body, { headers: { Authorization: token } });
